import { createRouter, createWebHistory } from 'vue-router';
import MeetingApplication from '../views/home/application/MeetingApplication.vue';
import MeetingMgmt from '../views/home/meeting-mgmt/meetingMgmt.vue';
import QuotaManagement from '../views/home/meeting-mgmt/QuotaManagement.vue';
// 会议申请页面 - 使用新的MeetingApplication组件
import SpeakerDetail from '../components/SpeakerDetail.vue';
import Login from '../views/Login.vue';
import ProfilePage from '../views/person/ProfilePage.vue';
import Home from '../views/home/Home.vue';
import MeetingConfirmation from '../views/MeetingConfirmation.vue';
import MeetingConfirmDetail from '../views/MeetingConfirmDetail.vue';
import ProjectInfo from '../views/person/ProjectInfo.vue';
import FeedbackPage from '../views/person/FeedbackPage.vue';
import SystemManagement from '../views/home/system-mgmt/SystemManagement.vue';

const routes = [
  {
    path: '/apply',
    name: 'ApplyMeeting',
    component: MeetingApplication
  },
  {
    path: '/meeting/:id/edit',
    name: 'EditMeeting',
    component: MeetingApplication
  },
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/confirm',
    name: 'ConfirmMeeting',
    component: MeetingConfirmation
  },
  {
    path: '/my-meetings',
    name: 'MyMeetings',
    component: MeetingConfirmation
  },
  {
    path: '/meeting-confirm/:id',
    name: 'MeetingConfirmDetail',
    component: MeetingConfirmDetail
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage
  },
  {
    path: '/project-info',
    name: 'ProjectInfo',
    component: ProjectInfo
  },
  {
    path: '/speaker/:id/detail',
    name: 'SpeakerDetail',
    component: SpeakerDetail
  },
  {
    path: '/my-speakers',
    name: 'MySpeakersList',
    component: () => import('../components/MySpeakersList.vue')
  },
  {
    path: '/my-speakers-cp',
    name: 'MySpeakersListCopy',
    component: () => import('../views/speakers/MySpeakersCopy.vue')
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: FeedbackPage
  },
  {
    path: '/meeting-mgmt',
    name: 'MeetingMgmt',
    component: MeetingMgmt
  },
  {
    path: '/quota-mgmt',
    name: 'QuotaManagement',
    component: QuotaManagement
  },
  {
    path: '/system',
    name: 'SystemManagement',
    component: SystemManagement
  },
  {
    path: '/password-change',
    name: 'PasswordChange',
    component: () => import('../views/person/PasswordChangeView.vue')
  },
  {
    path: '/personal-info',
    name: 'PersonalInfo',
    component: () => import('../views/person/PersonalInfo.vue')
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;